document.addEventListener('team:theme:updated', (event) => {
    document.querySelectorAll('[data-theme-themed]').forEach(element => {
        element.style = event.detail.variables.join(' ');
    })
});
